/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_UpdateInputs */



/**
* | output |
* | --- |
* | "Cancel Update" |
*
* @param {Cancel_UpdateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_update = /** @type {((inputs?: Cancel_UpdateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_UpdateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler la mise à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisierung abbrechen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla aggiornamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменить обновление")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar actualización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("取消更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新をキャンセル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट रद्द करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancelar atualização")
	return /** @type {LocalizedString} */ ("Cancel Update")
});